export const COMPANY_ID = process.env.REACT_APP_COMPANY_ID || '1';
